import { BreadcrumbProvider, useBreadcrumbContext } from './context/BreadcrumbContext';
import { BreadcrumbContent, BreadcrumbList } from './lib';

/** @typedef {import('./lib/propTypes').BreadcrumbStep} BreadcrumbStep */
/** @typedef {import('./lib/propTypes').BreadcrumbContext} BreadcrumbCtx */

const BreadcrumbConsumer = ({ children }) => {
  const ctx = useBreadcrumbContext();
  return typeof children === 'function' ? children(ctx) : children;
};

/**
 * @param {Object} props
 * @param {BreadcrumbStep[]} props.steps - Initial breadcrumb steps
 * @param {((ctx: BreadcrumbCtx) => React.ReactNode) | React.ReactNode} props.children
 */

const Breadcrumb = ({ children, ...rest }) => (
  <BreadcrumbProvider {...rest}>
    <BreadcrumbConsumer>{children}</BreadcrumbConsumer>
  </BreadcrumbProvider>
);

export { BreadcrumbContent, BreadcrumbList };
export default Breadcrumb;
